import type { ClientSubGroup } from '@maru44/huntre-utils/src/models/clientSubGroup'
import { getData } from '@maru44/huntre-utils/src/utils/data'
import { collection, getDocs } from 'firebase/firestore'
import { useCallback } from 'react'
import { firestore } from 'src/utils/firebase'

export const useClientSubGroups = () => {
  const listClientSubGroups = useCallback(async (clientId: string): Promise<ClientSubGroup[]> => {
    if (!clientId) return []
    const ref = collection(firestore, `clients/${clientId}/clientSubGroups`)
    const snap = await getDocs(ref)
    return snap.docs.map((v) => getData<ClientSubGroup>(v))
  }, [])

  return { listClientSubGroups }
}
